<template>
  <div>手动发放</div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>